export default {
  namespaced: true,
  state: {
    items: {}
  },
  getters: {
    items: state => state.items,
  },
  mutations: {},
  actions: {
    createTag: ({ dispatch }, item) => dispatch('createItem', { resource: 'tags', item }, { root: true }),
    fetchTag: ({ dispatch }, { id }) => dispatch('fetchItem', { resource: 'tags', id }, { root: true }),
    fetchTags: ({ dispatch }, { ids }) => dispatch('fetchItems', { resource: 'tags', ids }, { root: true }),
    findTag: ({ dispatch }, query) => dispatch('findItem', { resource: 'tags', query }, { root: true }),
    findTags: ({ dispatch }, query) => dispatch('findItems', { resource: 'tags', query }, { root: true }),
    updateTag: ({ dispatch }, { id, data }) => dispatch('updateItem', { resource: 'tags', id, data }, { root: true }),
  }
};
